import { ALLOWED_EXTENSIONS } from '../../../../features/cost-report/types';

export function ObjectsToFormDataCoverter(obj: Record<string, unknown>): FormData {
    const formData = new FormData();

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];

            if (value instanceof Array) {
                if (value) {
                    for (let i = 0; i < value.length; i++) {
                        formData.append(key, value[i]);
                    }
                }

            } else if (value !== null && value !== undefined) {
                formData.append(key, value.toString());
            }
        }
    }

    return formData;
};

export function IsValidExtension(file: File): boolean {
    const fileName = file.name;
    const lastDotIndex = fileName.lastIndexOf('.');
    
    if (lastDotIndex === -1 || lastDotIndex === 0) {
        return false;
    }

    const extension = fileName.slice(lastDotIndex + 1).toLowerCase();
    return ALLOWED_EXTENSIONS.includes(extension);
};
